import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Link from "next/link";
import Image from "next/image";
import { NAV_ITEMS, NavItem, NAV_BUTTON } from "../header.constants";
import { BiChevronRight, BiChevronDown } from "@onemind-services-llc/react-icons-ng/bi";
import { BUTTON_VARIANTS } from "@/theme/components/button";

export const DesktopNav = () => {
  const linkColor = useColorModeValue("gray.600", "gray.200");
  const linkHoverColor = useColorModeValue("gray.800", "white");
  const popoverContentBgColor = useColorModeValue("white", "gray.800");

  return (
    <Stack direction={"row"} spacing={4} align={"center"}>
      {NAV_ITEMS.map((item) => (
        <Box
          key={item.label}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Popover trigger={"hover"} placement={"bottom-start"}>
            <PopoverTrigger>
              <Box
                as={"a"}
                p={2}
                href={item.href ?? "#"}
                fontWeight={500}
                fontSize={"18px"}
                color={linkColor}
                _hover={{
                  textDecoration: "none",
                  color: linkHoverColor,
                }}
                // textAlign={"center"}
              >
                <Flex textAlign={"center"}>
                  {item.icon && <Icon as={item.icon} boxSize={8} />}
                  {item.image && (
                    <Image src={item.image} alt={item.label} width={20} height={20} />
                  )}
                  {item.label}
                  {item.children && (
                    <Icon
                      as={BiChevronDown}
                      transition={"all .25s ease-in-out"}
                      alignSelf={"center"}
                      w={5}
                      h={5}
                    />
                  )}{" "}
                </Flex>
              </Box>
            </PopoverTrigger>

            {item.children && (
              <PopoverContent
                border={"1px solid #eee"}
                boxShadow={"sm"}
                bg={popoverContentBgColor}
                p={"10px"}
                rounded={"xl"}
                minW={"350px"}
                fontSize={"18px"}
              >
                <Stack>
                  {item.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
      <Button
        as={Link}
        href={NAV_BUTTON.href}
        variant={BUTTON_VARIANTS.BRAND}
        whiteSpace={"normal"}
        textAlign={"center"}
      >
        {NAV_BUTTON.label}
      </Button>
    </Stack>
  );
};

const DesktopSubNav = ({ icon, image, label, href, children }: NavItem) => {
  const hasChildren = children && children.length > 0;
  const popoverContentBgColor = useColorModeValue("white", "gray.800");

  return (
    <Popover trigger={"hover"} placement={"right-start"}>
      <PopoverTrigger>
        <Box
          as={"a"}
          href={href ?? "#"}
          role={"group"}
          display={"block"}
          p={2}
          rounded={"md"}
          _hover={{ bg: useColorModeValue("blue.50", "gray.900") }}
        >
          <Stack direction={"row"} align={"center"}>
            <HStack spacing={4}>
              {icon && <Icon as={icon} boxSize={6} />}
              {image && <Image src={image} alt={label} width={20} height={20} />}
              <Text
                transition={"all .3s ease"}
                _groupHover={{ color: "blue.400" }}
                fontWeight={500}
              >
                {label}
              </Text>
            </HStack>
            {hasChildren && (
              <Flex
                transition={"all .3s ease"}
                transform={"translateX(-10px)"}
                _groupHover={{ color: "blue.400" }}
                justify={"flex-end"}
                align={"center"}
                flex={1}
              >
                <Icon as={BiChevronRight} w={5} h={5} />
              </Flex>
            )}
          </Stack>
        </Box>
      </PopoverTrigger>

      {children && (
        <PopoverContent
          border={"1px solid #eee"}
          boxShadow={"sm"}
          bg={popoverContentBgColor}
          p={"10px"}
          rounded={"xl"}
          minW={"350px"}
        >
          <Stack>
            {children.map((child) => (
              <DesktopSubNav key={child.label} {...child} />
            ))}
          </Stack>
        </PopoverContent>
      )}
    </Popover>
  );
};
